import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { catchError, map, Observable, of } from 'rxjs';

import { EnvironmentConfig } from '../config/environment.config';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {
  constructor(
    @Inject('environment') private environment: EnvironmentConfig,
    private http: HttpClient
  ) {}

  getIsSurveyTested(projectId: string, methodId: string): Observable<boolean | null> {
    return this.http.get<boolean | null>(`${this.environment.endPoint}project/${projectId}/research/${methodId}/survey/tested`).pipe(
      map((result) => result),
      catchError(() => of(null))
    );
  }
}
